import React from 'react';

export const Share = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.7714 4.08585L22.7939 11.5702C23.0648 11.7724 23.0648 12.2276 22.8165 12.4298L12.794 19.9142C12.5005 20.1417 12.0942 19.8889 12.0942 19.4843V14.6667C10.2839 14.6667 8.07143 15.5556 6.45093 16.2226C6.45093 16.2226 3.44869 17.8408 1.7557 19.459C1.4171 19.7624 0.920492 19.4337 1.01079 18.9533C1.52997 16.3743 2.5865 14.8734 4.4375 12.8C6.67676 10.6667 10.4991 9.33333 12.0717 9.33333V4.51569C12.0717 4.11113 12.478 3.85829 12.7714 4.08585Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
